class ProductListingPrice extends HTMLElement {
  constructor() {
    super();

    this.reguralPrice = this.dataset.price;
    this.productId = this.dataset.productId;
    this.firstVariantId = this.dataset.firstVariantId;

    document.body.addEventListener('discount:change', this.handleDiscountChange.bind(this));
  }

  removeTrailingZeros(num) {
    let strNum = num.toString();
    if (strNum.includes('.')) {
      strNum = strNum.replace(/\.?0+$/, '');
    }
    return strNum;
  }

  handleDiscountChange(event) {
    this.discount = event.detail;
    this.updatePrice();
  }

  formatPrice(value) {
    return `$${this.removeTrailingZeros(value)}`;
  }

  rednerPrice() {
    if (this.discountedPrice) {
      this.innerHTML = `
        <span class="line-through">${this.formatPrice(this.reguralPrice)}</span>
        ${this.formatPrice(this.discountedPrice)}/mo
      `;
    } else {
      this.innerHTML = this.formatPrice(this.reguralPrice) + '/mo';
    }
  }

  updatePrice() {
    if (!this.reguralPrice) {
      return;
    }

    if (
      this.discount != null &&
      (this.discount?.products.includes(this.productId) || this.discount?.variants.includes(this.firstVariantId))
    ) {
      // Apply discount
      if (this.discount.amount) {
        this.discountedPrice = this.reguralPrice - this.discount.amount;
      } else if (this.discount.percentage) {
        const discountAmount = this.reguralPrice * this.discount.percentage;
        this.discountedPrice = this.reguralPrice - discountAmount;
      }

      this.rednerPrice();
    }
  }
}

customElements.define('product-listing-price', ProductListingPrice);
